module.exports = __webpack_public_path__ + "img/diaoli.f794a6b3.png";